import {Component, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ResetService, SimpleState} from 'compob2b-auth';
import {ApiResponse, BaseComponent} from 'compob2b-libs';
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

const MIN_LENGTH = 6;

@Component({
    selector: 'app-customer-reset',
    templateUrl: './customer-reset.component.html',
    styleUrls: ['./customer-reset.component.scss'],
    standalone: false
})
export class CustomerResetComponent extends BaseComponent implements OnInit {
  isValidPassFields: Subject<boolean>;
  isValidForm: Observable<boolean>;
  state: SimpleState;
  /**
   * FormGroup - group of form elements (inputs) with validators
   * {@link https://angular.io/guide/forms-overview#common-foundation}
   * {@link https://angular.io/guide/form-validation}
   */
  resetForm = new UntypedFormGroup({
    password: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(MIN_LENGTH),
    ]),
    repeatPassword: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(MIN_LENGTH),
    ]),
  });

  constructor(
    private readonly resetService: ResetService,
    private readonly route: ActivatedRoute
  ) {
    super();
    this.loading = true;
    this.state = this.resetService.getState();
  }

  ngOnInit(): void {
    this.handleToken();
  }

  private handleToken() {
    this.resetService
      .validateToken(this.route.snapshot.queryParams)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        () => this.handleTokenSuccess(),
        () => this.handleTokenError()
      );
  }

  /**
   * CompoToken is valid
   */
  private handleTokenSuccess() {
    this.resetService.tokenValidatedSuccessfully();
    this.isValidForm = this.resetService.validate(this.resetForm);
    this.isValidPassFields = this.resetService.passFields();
    this.loading = false;
  }

  private handleTokenError() {
    this.resetService.tokenNotValidated();
    this.loading = false;
  }

  /**
   * Handles success result of request
   * @param response ApiResponse
   */
  private successHandler(response: ApiResponse<string>): void {
    this.resetService.resetSuccess();
    this.loading = false;
  }

  /**
   * Handles failed result of request
   */
  private errorHandler(): void {
    this.resetService.resetError();
    this.loading = false;
  }

  onSubmit() {
    if (this.resetForm.valid) {
      this.loading = true;
      this.resetService
        .resetPassword(this.resetForm.value, this.route.snapshot.queryParams)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (response: ApiResponse<string>) => this.successHandler(response),
          _ => this.errorHandler()
        );
    }
  }
}
